import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {Control, ControlTypeEnum, FieldConfigName, FieldType, OptionCheckbox, OptionDate, OptionText} from '../../models';
import {FormulaireService} from '../../../../services/formulaire/formulaire.service';
import {map, switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-dm-elements',
  templateUrl: './fields-default-list.component.html',
  styleUrls: ['./fields-default-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FieldsDefaultListComponent implements OnInit {
  availableElements$: Observable<FieldConfigName[]>;
  filtredElements$: Observable<any>;
  constructor(
    private formulaireSvc: FormulaireService,
  ) {
  }

  ngOnInit(): void {
    this.getElements();
  }

  getElements() {
    this.availableElements$ = this.formulaireSvc.getDefaultElements();
    this.filtredElements$ = this.availableElements$.pipe(map(els => els.filter(el => (!el.hidden))));
  }

}
